import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="leaseAttachment";
export function insert(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}`,
     method: 'post',
     data:parameter
   })
}

export function deleteObj(fileId){
  return axios({
    url: `/ws/${moduleName}/${fileId}`,
    method: 'delete',
  })
}

export default {
  insert,deleteObj
}